import React from 'react';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import SwapHorizRoundedIcon from '@mui/icons-material/SwapHorizRounded';
import { ASSIGNABLE_ROLES, ROLE_GUIDE, OWNER_EXCLUSIVE, USER_ROLES } from '../../../constants/userRoles';
import { ROLE_ICONS, roleLabel } from './roleVisuals';
import styles from './RoleCards.module.css';

const peopleLabel = (count) => (count === 1 ? '1 pessoa' : `${count} pessoas`);

/**
 * Os papéis que se atribuem à equipe (Administrador(a) e Equipe), lado a lado, com o
 * que cada um acessa e quantas pessoas ativas têm o papel. Abaixo, o que só o
 * proprietário faz e, para o próprio responsável (onTransfer), o atalho para
 * transferir a conta. A marcação "Profissional de saúde" é independente do papel.
 */
function RoleCards({ counts, onTransfer }) {
  const OwnerIcon = ROLE_ICONS[USER_ROLES.COMPANY_OWNER];

  return (
    <section className={styles.wrapper} aria-label="Papéis da equipe">
      <div className={styles.grid}>
        {ASSIGNABLE_ROLES.map((role) => {
          const Icon = ROLE_ICONS[role];
          const { tagline, can, cannot } = ROLE_GUIDE[role];
          return (
            <article key={role} className={styles.card}>
              <header className={styles.cardHeader}>
                <span className={styles.icon}><Icon fontSize="small" /></span>
                <div className={styles.titleBlock}>
                  <h3 className={styles.title}>{roleLabel(role)}</h3>
                  <span className={styles.count}>{peopleLabel(counts[role] || 0)}</span>
                </div>
              </header>
              <p className={styles.tagline}>{tagline}</p>
              <ul className={styles.list}>
                {can.map((item) => (
                  <li key={item} className={styles.can}>
                    <CheckRoundedIcon className={styles.mark} />{item}
                  </li>
                ))}
                {cannot.map((item) => (
                  <li key={item} className={styles.cannot}>
                    <CloseRoundedIcon className={styles.mark} />{item}
                  </li>
                ))}
              </ul>
            </article>
          );
        })}
      </div>

      <div className={styles.owner}>
        <span className={styles.ownerIcon}><OwnerIcon fontSize="small" /></span>
        <p className={styles.ownerText}>
          <strong>Proprietário(a).</strong> Responsável pela conta: tem acesso a tudo
          e é a única pessoa que pode: {OWNER_EXCLUSIVE.map((item) => item.charAt(0).toLowerCase() + item.slice(1)).join('; ')}.
        </p>
        {onTransfer && (
          <button type="button" className={styles.ownerAction} onClick={onTransfer}>
            <SwapHorizRoundedIcon fontSize="small" />
            Transferir a conta
          </button>
        )}
      </div>
    </section>
  );
}

export default RoleCards;
